import type { IteroOrder } from '../../../../../services/iteroBrowse';
import { TimelineCard } from './TimelineCard';

interface ScanTimelineProps {
    orders: readonly IteroOrder[];
    returnFocusRxId: string | null;
    onOpenOrder: (order: IteroOrder) => void;
}

// The rail runs from each dot's centre (21px, level with the card title) to the next dot's, 10px
// of gap further down. Dots are drawn after the rail so they sit on top of it.
const RAIL_CLASS = 'absolute left-[5px] top-[21px] -bottom-[31px] w-0.5 bg-gray-200';
const DOT_BASE_CLASS = 'absolute left-0 top-[15px] h-3 w-3 rounded-full border-2';

export function ScanTimeline({ orders, returnFocusRxId, onOpenOrder }: ScanTimelineProps) {
    return (
        <ol className="flex flex-col gap-2.5" aria-label="Scan history, newest first">
            {orders.map((order, index) => {
                const isNewest = index === 0;
                const isLast = index === orders.length - 1;
                return (
                    <li key={order.rxId} className="relative pl-6">
                        {!isLast && <span aria-hidden="true" className={RAIL_CLASS} />}
                        <span
                            aria-hidden="true"
                            className={`${DOT_BASE_CLASS} ${
                                isNewest
                                    ? 'border-gray-900 bg-gray-900'
                                    : 'border-gray-300 bg-white'
                            }`}
                        />
                        <TimelineCard
                            order={order}
                            autoFocus={order.rxId === returnFocusRxId}
                            onOpen={onOpenOrder}
                        />
                    </li>
                );
            })}
        </ol>
    );
}
